import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { AppLayout } from "../../components/layout/app-layout";
import AnalysisTab from "./tabs/analysis.tab";
import SurveysTab from "./tabs/surveys.tab";
import AgentTemplatesTab from "./tabs/agent-templates.tab";
import GenerateSurveyTab from "./tabs/generate-survey.tab";
import { useNavigate, useParams } from "react-router-dom";
import CreateSurvey from "../create-survey/create-survey";
import SurveyResultsPage from "../survey-results/survey-results.page";

const SurveysPage = () => {

  useSetPageTitle('Surveys');
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId?: string }>();

  const surveysTabs = [
    { id: '', key: 'ALL', label: 'Surveys' },
    { id: 'templates', key: 'templates', label: 'Templates' },
    { id: 'generate-survey', key: 'generate_survey', label: 'Generate Survey' },
    { id: 'view', key: 'NEVER', label: 'View Survey' },
    { id: 'create', key: 'NEVER', label: 'Create Survey' },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = surveysTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    if (clientId) {
      navigate(`/client/${clientId}/surveys/${tabId}`);
    } else {
      navigate(`/surveys/${tabId}`);
    }
  };

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/surveys"
      navbarProps={{
        showBackButton: false,
        backPath: "/surveys",
        tabs: surveysTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="space-y-6">
        {currentTab === '' && (
          <SurveysTab />
        )}
        {currentTab === 'analytics' && (
          <AnalysisTab />
        )}
        {currentTab === 'templates' && (
          <AgentTemplatesTab />
        )}
        {currentTab === 'generate-survey' && (
          <GenerateSurveyTab />
        )}
        {currentTab === 'view' && (
          <SurveyResultsPage />
        )}
        {currentTab === 'create' && (
          <CreateSurvey />
        )}
      </div>
    </AppLayout>
  );
};

export default SurveysPage;
